import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import SettingService from "services/SettingService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllMenuStore = createAsyncThunk(
  "setting/getAllMenuStore",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SettingService.GetAllMenuStore(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const addMenuStore = createAsyncThunk(
  "setting/addMenuStore",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SettingService.AddMenuStore(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateMenuStore = createAsyncThunk(
  "setting/updateMenuStore",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SettingService.UpdateMenuStore(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const delMenuStore = createAsyncThunk(
  "setting/delMenuStore",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SettingService.DeleteMenuStore(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const sortMenuStore = createAsyncThunk(
  "setting/sortMenuStore",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await SettingService.SortMenuStore(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  dataList: [],
};
export const settingMenuStoreSlice = createSlice({
  name: "settingMenuStore",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setDataList: (state, { payload }) => {
      state.dataList = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllMenuStore.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllMenuStore.fulfilled, (state, action) => {
        state.loading = false;
        state.dataList = action.payload;
      })
      .addCase(getAllMenuStore.rejected, (state, action) => {
        state.loading = false;
      })
      //add menu store
      .addCase(addMenuStore.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMenuStore.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addMenuStore.rejected, (state, action) => {
        state.loading = false;
      })
      //update menu store
      .addCase(updateMenuStore.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMenuStore.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMenuStore.rejected, (state, action) => {
        state.loading = false;
      })
      //del menu store
      .addCase(delMenuStore.pending, (state) => {
        state.loading = true;
      })
      .addCase(delMenuStore.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(delMenuStore.rejected, (state, action) => {
        state.loading = false;
      })
      //sort menu store
      .addCase(sortMenuStore.pending, (state) => {
        state.loading = true;
      })
      .addCase(sortMenuStore.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(sortMenuStore.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setDataList } = settingMenuStoreSlice.actions;

export default settingMenuStoreSlice.reducer;
